"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _rtl = require("../../utils/rtl");
var _defaultTheme = _interopRequireDefault(require("../../defaultTheme"));
var _Tag = require("../../Tag");
const StyledInputTags = _styledComponents.default.div.withConfig({
  displayName: "InputTags__StyledInputTags",
  componentId: "sc-1guohvu-0"
})(["position:relative;margin:", ";display:flex;align-items:center;flex:0 1 auto;height:100%;z-index:2;min-width:50px;overflow:hidden;"], ({
  theme
}) => (0, _rtl.rtlSpacing)(`0 0 0 ${theme.orbit.spaceSmall}`));
StyledInputTags.defaultProps = {
  theme: _defaultTheme.default
};
const StyledInputTagsInner = _styledComponents.default.div.withConfig({
  displayName: "InputTags__StyledInputTagsInner",
  componentId: "sc-1guohvu-1"
})(["overflow-x:scroll;white-space:nowrap;-ms-overflow-style:none;scrollbar-width:none;display:flex;align-items:center;&::-webkit-scrollbar{display:none;}", " + ", "{margin:", ";}"], _Tag.StyledTag, _Tag.StyledTag, ({
  theme
}) => (0, _rtl.rtlSpacing)(`0 0 0 ${theme.orbit.spaceXSmall}`));
StyledInputTagsInner.defaultProps = {
  theme: _defaultTheme.default
};
const InputTags = ({
  children
}) => {
  const tagsRef = React.useRef(null);
  React.useEffect(() => {
    const handleMouseMove = event => {
      if (tagsRef && tagsRef.current) {
        // @ts-expect-error TODO
        const {
          isDragging
        } = tagsRef.current;
        if (isDragging && event.movementX) {
          tagsRef.current.scrollLeft -= event.movementX;
        }
      }
    };
    const handleMouseUp = () => {
      if (tagsRef && tagsRef.current) {
        // @ts-expect-error TODO
        tagsRef.current.isDragging = false;
      }
    };
    const tags = tagsRef.current;
    if (tags) {
      // @ts-expect-error TODO
      tags.addEventListener("mousemove", handleMouseMove);
      // @ts-expect-error TODO
      tags.addEventListener("mouseup", handleMouseUp);
    }
    return () => {
      if (tags) {
        // @ts-expect-error TODO
        tags.removeEventListener("mousemove", handleMouseMove);
        // @ts-expect-error TODO
        tags.removeEventListener("mouseup", handleMouseUp);
      }
    };
  }, [tagsRef]);
  return /*#__PURE__*/React.createElement(StyledInputTags, null, /*#__PURE__*/React.createElement(StyledInputTagsInner, {
    ref: tagsRef,
    onMouseDown: () => {
      if (tagsRef && tagsRef.current) {
        // @ts-expect-error TODO
        tagsRef.current.isDragging = true;
      }
    }
  }, children));
};
var _default = InputTags;
exports.default = _default;